import { tv, type VariantProps } from "tailwind-variants"
export type ObjectFitVariantProps = VariantProps<typeof objectFitVariants>

export const objectFitVariants = tv({
  variants: {
    objectFit: {
      contain: "object-contain",
      cover: "object-cover",
      fill: "object-fill",
      none: "object-none",
      "scale-down": "object-scale-down",
    },
  },
})
